import { existsSync, readFileSync } from 'node:fs';
import { dirname, join } from 'node:path';
import { fileURLToPath } from 'node:url';
import { type Registry, type RegistryItem, registrySchema } from './schema.js';

function getDistRegistryBaseDir(): string {
  const currentFile = fileURLToPath(import.meta.url);
  const currentDir = dirname(currentFile);
  // dist/index.js -> dist/registry
  return join(currentDir, 'registry');
}

export function loadLocalRegistry(): Registry {
  const base = getDistRegistryBaseDir();
  const registryPath = join(base, 'r', 'registry.json');
  if (!existsSync(registryPath)) {
    throw new Error(`Registry file not found: ${registryPath}`);
  }
  const content = readFileSync(registryPath, 'utf-8');
  const data = JSON.parse(content);
  return registrySchema.parse(data);
}

export function getAllRegistryItems(): RegistryItem[] {
  return loadLocalRegistry().items;
}

export function getRegistryItem(name: string): RegistryItem | undefined {
  return getAllRegistryItems().find((i) => i.name === name);
}

export function loadRegistryItemWithContent(name: string): RegistryItem {
  const base = getDistRegistryBaseDir();
  const componentPath = join(base, 'r', 'components', `${name}.json`);
  if (!existsSync(componentPath)) {
    throw new Error(`Component not found: ${componentPath}`);
  }
  const content = readFileSync(componentPath, 'utf-8');
  const data = JSON.parse(content);
  return registrySchema.parse({ name: 'single', items: [data] }).items[0];
}

export { type Registry, type RegistryItem, registrySchema } from './schema.js';
